import React, {useEffect,useRef, useState} from 'react'
import styled from "styled-components"
import {useSelector, useDispatch} from "react-redux"
import Channel from "./Channel"
import {setPlayingChannel} from "../../actions/playingChannel"
import { FixedSizeList as List } from "react-window";
import {convertRemToPixels,convertVhToPixels} from "../../other/convert-rem"
import {useHistory,useLocation} from "react-router-dom";
import Popup from "../Popup/Popup"

const ChannelsList = styled.ul`
height: calc(95vh - 3rem);
padding: .8rem .6rem;
background-color: var(--first-color);
list-style-type: none;
border-left: 1px solid #000;
transform: translateY(-1px);
box-shadow: 0 7px 14px rgb(50 50 93 / 10%), 0 3px 6px rgb(0 0 0 / 8%);
&:focus{
    outline-width: 0px;
}
`

const Channels = ({playlist}) => {
    const playingChannel = useSelector(state => state.playingCh);
    
    const query = useQuery();
    const searchText = query.get("search");
    
    const [showPopup, setShowPopup] = useState(false);
    const [channelsPlaylist, setChannelsPlaylist] = useState(playlist);


    const dispatch = useDispatch()
    const history = useHistory();
    const location = useLocation();
    const listRef = useRef();

    
    useEffect(() => {
      if(playingChannel){
        setTimeout(()=>focusChannel(),100)
      }
    }, [playingChannel]);

    useEffect(() => {
      setChannelsPlaylist(playlist)
      setTimeout(()=>focusChannel(),100)
    }, [playlist]);


    useEffect(() => {
      if (!playlist) return;
      const searched = searchText ? playlist.filter(x=> x && x.name && x.name.toLowerCase().includes(searchText.toLowerCase())) : playlist;
      if(searched && searched.length > 0){
        setChannelsPlaylist(searched)
        setTimeout(() => focusChannel(), 100);
      }else if(searchText)
        setShowPopup(1)
      else if (location.pathname.includes("search")) history.push("/live/category/")
    }, [searchText, playlist, history, location.pathname]);

    const focusChannel = () => {
      if(document.getElementById("selectedCh"))
        document.getElementById("selectedCh").focus()
      else if(document.querySelector(".channel"))
        document.querySelector(".channel").focus()
    }


    const Row = ({ index, style }) => {
        const item = channelsPlaylist[index];
        if (!item) return null;

        return (
            <Channel key={item.stream_id} 
                    Name={item.name} 
                    Shift = {item.shift} 
                    Epg={item.epg_channel_id} 
                    id={item.stream_id} Image={item.stream_icon} 
                    Number={item.num} 
                    selectEvent={() => {
                        dispatch(setPlayingChannel(item))
                    }}
                    virtualScrollStyle={style} 
                    selected={playingChannel && playingChannel.stream_id === item.stream_id} />
        );
    };

    return (
      <>
        <ChannelsList tabIndex={0} >
            <List
              height={convertVhToPixels("95vh")-convertRemToPixels(5)}
              itemCount={channelsPlaylist.length}
              itemSize={convertRemToPixels(5)}
              style={{overflowY:"auto", maxHeight: "calc(95vh - 3rem)"}}
              useIsScrolling={true}
              ref={listRef}
            >
              {Row}
            </List>          
        </ChannelsList>
        {showPopup && <Popup title={`No stream found with '${searchText}'`} description={"Search will be resetted."} icon={"fas fa-search"}  onclick={()=>{
          setShowPopup(0);
          focusChannel();
          history.replace(location.pathname.split("?")[0])
        }}/>}
      </>
    )
}

const useQuery = () => {
  return new URLSearchParams(useLocation().search);
}

export default Channels
